"use client";
import { useContext } from "react";
import { PortalContainerContext } from "./portalContainerContext.js";
function usePortalContainer() {
    return useContext(PortalContainerContext);
}
export { usePortalContainer };
